// extracted by extract-css-chunks-webpack-plugin
module.exports = {"xs":"575px","sm":"767px","md":"991px","lg":"1199px","xl":"1399px","xxl":"1919px","xxxl":"2399px"};